import { render, staticRenderFns } from "./ipt-image.vue?vue&type=template&id=cc61e0f2&scoped=true&"
import script from "./ipt-image.vue?vue&type=script&lang=ts&"
export * from "./ipt-image.vue?vue&type=script&lang=ts&"
import style0 from "./ipt-image.vue?vue&type=style&index=0&id=cc61e0f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc61e0f2",
  null
  
)

export default component.exports